// extracted by mini-css-extract-plugin
export default {"layout":"order-page_layout__jh7nG","columns":"order-page_columns__VDeP5","widget":"order-page_widget__pH1YW"};